var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{attrs:{"placement":"top","effect":"dark","popper-class":"leo-knowledge-tip-popper"}},[_c('div',{staticClass:"leo-tip-rich",attrs:{"slot":"content"},slot:"content"},[_vm._v(_vm._s(_vm.tip))]),_vm._v(" "),_c('i',{staticClass:"el-icon-question leo-inline-option-tip-icon"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d609243e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LeoKnowledge/LeoInlineOptionTip.vue
// module id = null
// module chunks = 